module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"externalCode":"Ekstern kode","internalCode":"Intern kode"},"en":{"externalCode":"External code","internalCode":"internal code"}}')
  delete Component.options._Ctor
}
